/**
 *
 * @param {object} currentOrdersDict: the current state of orders in a dictionary
 * @param {array} currentBeingProcessedOrders: the current state of order being processed in a list
 * @param {array} newOrdersList: the updated ticket list coming from the API
 * @returns {array} the updated being processed order list. Removes orders that have been it 'queue' property changed
 */
const updateBeingProcessedOrderIds = (
  currentOrdersDict,
  currentBeingProcessedOrders,
  newOrdersList,
) => {
  return currentBeingProcessedOrders.filter(orderId => {
    const newOrder = newOrdersList.filter(
      order => order.id === orderId && order.currentTicket.queue,
    )[0];

    if (newOrder) {
      const { currentTicket } = currentOrdersDict[orderId];
      const currentOrderQueue = currentTicket.queue;
      const { currentTicket: newTicket } = newOrder;
      const isTicketQueueTheSame = newTicket.queue && currentOrderQueue === newTicket.queue;
      const isAssignedToCurrentUserTheSame =
        currentTicket.isAssignedToCurrentUser === newTicket.isAssignedToCurrentUser;

      return isTicketQueueTheSame && isAssignedToCurrentUserTheSame;
    }

    // Keep the order in the array
    return true;
  });
};

export default updateBeingProcessedOrderIds;



// WEBPACK FOOTER //
// ./src/reducer/update-processing-order-ids/index.js